import { useStatsigClient } from '@statsig/react-bindings';
import useDevice from '../../../hooks/use-device';
import { world } from '../../../languages';
import { AVAILABLE_WORLDS } from '../../../languages/constants';
import serializeQueryParams from '../../../utils/url/serialize-query-params';
import { StatsigABTestDataType } from '../ab-tests';

const useStatsigVariant = (props: StatsigABTestDataType, needsInitTest = true): string => {
    const { statsigKey, layerName, limitedWorlds, allowedDevices } = props;

    const queryParams = serializeQueryParams() as Record<string, string | undefined>;
    const { getExperiment, getLayer } = useStatsigClient();
    const device = useDevice();

    if (!needsInitTest || (limitedWorlds !== undefined && !limitedWorlds.includes(world as AVAILABLE_WORLDS))) {
        return '';
    }

    if (allowedDevices !== undefined && !allowedDevices.includes(device)) {
        return '';
    }

    if (queryParams[statsigKey]) {
        return queryParams[statsigKey] as string;
    }

    const variant = (
        layerName ? getLayer(layerName).get(statsigKey, '') : getExperiment(statsigKey).get(statsigKey)
    ) as string;

    if (!window.statsigVariant) {
        window.statsigVariant = {};
    }

    window.statsigVariant[statsigKey] = () => {
        return variant;
    };

    return variant;
};

export default useStatsigVariant;
